// extracted by mini-css-extract-plugin
module.exports = {"root":"AccordionBlock_root__zCfHL"};